import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FILTER_VARIANT_API } from "./apiRoutes";

interface UseGetFilterVariantListProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getFilterVariantList = async (communityId: string) =>
  await axiosAuth.get(`${FILTER_VARIANT_API}/community/${communityId}`);

const useGetFilterVariantList = ({
  queryParams,
  communityId
}: UseGetFilterVariantListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["managerial-filter-variant-list", communityId],
    queryFn: () => getFilterVariantList(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetFilterVariantList;
